var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownlaod({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1016"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 133",
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.5 18.5L13.0625 15.375L14.025 14.4687L15.8125 16.0937V11H17.1875V16.0937L18.975 14.4687L19.9375 15.375L16.5 18.5ZM12.375 21C11.9969 21 11.6733 20.8777 11.4042 20.6331C11.1352 20.3885 11.0005 20.0942 11 19.75V17.875H12.375V19.75H20.625V17.875H22V19.75C22 20.0937 21.8655 20.3881 21.5964 20.6331C21.3274 20.8781 21.0036 21.0004 20.625 21H12.375Z",
    fill: "#595959"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownlaod);
export default __webpack_public_path__ + "static/media/downlaod.8b7675f1f62bd12b32ebd24e5bd76a44.svg";
export { ForwardRef as ReactComponent };